var descwords = ['desc', 'reverse'];

var filter = require('lodash.filter');

var _require = require('./typeCheck'),
    isString = _require.isString,
    isObject = _require.isObject;

var objToArray = function objToArray(val) {
  return Object.keys(val).map(function (x) {
    return {
      key: x,
      value: val[x]
    };
  });
};

var getMissingVals = function getMissingVals(originalArray, key) {
  return filter(originalArray, function (x) {
    return !x[key];
  });
};

var injMissVals = function injMissVals(originalArray, sortedArray, key) {
  var miss = getMissingVals(originalArray, key);
  return miss.length > 0 ? sortedArray.concat(miss) : sortedArray;
};

var getLowCasVal = function getLowCasVal(val) {
  return String(val).toLowerCase();
};

var getSortArray = function getSortArray(order) {
  return order === 'desc' ? [1, -1, 0] : [-1, 1, 0];
};

var getSortFunctionInsensitive = function getSortFunctionInsensitive(i, key) {
  return function (a, b) {
    return getLowCasVal(a[key]) < getLowCasVal(b[key]) ? i[0] : getLowCasVal(b[key]) < getLowCasVal(a[key]) ? i[1] : i[2];
  };
};

var getSortFunctionStandard = function getSortFunctionStandard(i, key) {
  return function (a, b) {
    return a[key] < b[key] ? i[0] : b[key] < a[key] ? i[1] : i[2];
  };
};

var getSortFunction = function getSortFunction(order, key, casesensitive) {
  return casesensitive === true ? getSortFunctionInsensitive(getSortArray(order), key) : getSortFunctionStandard(getSortArray(order), key);
};

var getSortOrder = function getSortOrder(params) {
  return isString(params) && descwords.indexOf(params) > -1 ? 'desc' : isObject(params) && descwords.indexOf(params.order) > -1 ? 'desc' : undefined;
};

var getCaseSensitivity = function getCaseSensitivity(params) {
  return isObject(params) && params.caseinsensitive;
};

function getSortedArray(arrayToSort, key, orderOrConfig) {
  var sortFunction = getSortFunction(getSortOrder(orderOrConfig), key, getCaseSensitivity(orderOrConfig));
  return filter(arrayToSort, function (x) {
    return Boolean(x[key]);
  }).sort(sortFunction);
}

module.exports = {
  objToArray: objToArray,
  injMissVals: injMissVals,
  getSortFunction: getSortFunction,
  getSortOrder: getSortOrder,
  getCaseSensitivity: getCaseSensitivity,
  getSortedArray: getSortedArray
};